import { ImageIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { EmptyState } from "@/components/ui";
import { FileDropzone } from "@/components/common";
import { FILE_ACCEPT } from "@/constants/fileAccept";
import { cn } from "@/lib/utils";

interface MediaCarouselEmptyProps {
  editable: boolean;
  className?: string;
  onSelectFiles: (files: File[]) => void;
}

export function MediaCarouselEmpty({
  editable,
  className,
  onSelectFiles,
}: MediaCarouselEmptyProps) {
  const { t } = useTranslation("activities");

  if (editable) {
    return (
      <div className={cn("space-y-4", className)}>
        <FileDropzone
          id="media-carousel-empty-upload"
          accept={FILE_ACCEPT.imageAndVideo}
          multiple
          className="h-64 rounded-xl"
          title={t("media.emptyEditableTitle")}
          description={t("media.emptyEditableHint")}
          onFilesSelected={onSelectFiles}
        />
      </div>
    );
  }

  return (
    <EmptyState
      size="md"
      icon={ImageIcon}
      title={t("media.emptyReadOnly")}
      className={cn("h-64 rounded-xl bg-surface-100", className)}
    />
  );
}
